import Header from '../../../__Layout/Header';
import React from "react";
import Loader from '../../../utils/Loader';
import { useGetstudentFreeCourseTopicQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import "../../../assets/niceapms/assets/css/style.css"
import {Link, useParams } from 'react-router-dom';

export default function StudentCourseTopic() {   
    let { course_id } = useParams();
    
    const param= 'courseId='+course_id;
    
    const {
        data: studentFreeCourse,
        isLoading: freeCourseDetail,
    } = useGetstudentFreeCourseTopicQuery({ pageUrl, params: param });
    if(freeCourseDetail) return  <Loader></Loader>
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training  </h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training</button>
                        </li>
                        <li>
                            <Link to={`/student-course`} className='btn btn-dark pull-right'>
                                            Back
                            </Link>
                        </li>
                       
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-12'>
                                   <table className='table table-resposive table-bordered'>
                                     <thead>
                                        <tr className='bg-warning'>
                                            <th>
                                                Course Detail 
                                            </th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                     {studentFreeCourse?.LessonList?.map((item,index) => { 
                                             
                                            return (                                 
                                                <tr key={index}>
                                                    <th>
                                                        <Link to={`/free-course-topic-details/${item.coursecode}/${item.lessonid}`}>
                                                           + {item.lesson_name}
                                                        </Link>
                                                    </th>
                                                </tr> 
                                            )  
                                        })  
                                        }
                                     </tbody>
                                    </table>                                              

                                   </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
